import BaseApiService from '@/services/common/api/baseApiService';

class SubordinatesService extends BaseApiService {
  loadSubordinates(paginationData) {
    return this.makeRequest(this.httpClient.get(this.apiRoutes
      .subordinates, {
      params: {
        pageSize: paginationData.pageSize,
        pageNumber: paginationData.pageNumber,
        filterQuery: paginationData.filterQuery,
        clients: paginationData.clients,
      },
    }));
  }

  loadSubordinateInfo(subordinateId) {
    return this.makeRequest(this.httpClient.get(this.apiEndPointsBuilder
      .subordinatesInfo(subordinateId)));
  }

  updateSubscription(subordinateId, isSubscribed) {
    return this.makeRequest(this.httpClient.post(this.apiEndPointsBuilder
      .subordinatesUpdateSubscription(subordinateId), {
      isSubscribed,
    }));
  }

  loadClients() {
    return this.makeRequest(this.httpClient.get(this.apiRoutes.subordinatesClients));
  }
}

export default SubordinatesService;
